
const servicesData = [
    {
        value: 'flight',
        icon: 'plane',
        height: 22,
        title: 'Flight'
    },
    {
        value: 'hotel',
        icon: 'bed',
        height: 16,
        title: 'Hotel'
    },
    {
        value: 'car',
        icon: 'taxi',
        height: 18,
        title: 'Car Rental'
    },
    {
        value: 'visa',
        icon: 'taxi',
        height: 18,
        title: 'Visa'
    }
];


export default servicesData;